import { render, staticRenderFns } from "./dealPage.vue?vue&type=template&id=77bffb85&scoped=true&"
import script from "./dealPage.vue?vue&type=script&lang=js&"
export * from "./dealPage.vue?vue&type=script&lang=js&"
import style0 from "./dealPage.vue?vue&type=style&index=0&id=77bffb85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bffb85",
  null
  
)

export default component.exports